// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"ContentHeading_imageWrapper___woq4","imageWrapperInner":"ContentHeading_imageWrapperInner__ZOV3w","labelWrapper":"ContentHeading_labelWrapper___INUi"};